export default __webpack_public_path__ + "static/media/add-person.6729edd6.png";